export default __webpack_public_path__ + "static/media/charm-s1.867c4420.png";